import React from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

import AppDialog from '@/Components/AppDialog/AppDialog'
import { Box } from '@mui/material'

const IdleTimeoutPrompt = (props) => {
    const renderTime = (remainingTime, kedo) => {
        return (
            <div className="timer">
                <div className="text">{kedo.t('Remaining')}</div>
                <div className="value">{remainingTime}</div>
                <div className="text">{kedo.t('seconds')}</div>
            </div>
        )
    }

    const duration = Math.floor(props.promptTimeout / 1000)

    return (
        <AppDialog
            aria-labelledby="contained-modal-title-vcenter"
            open
            maxWidth={'xs'}
            fullWidth
            title={''}
            contentProps={{ dividers: true }}
            BackdropProps={{
                className: 'inactive-backdrop',
            }}
            className={'modal-inactive inactivePopUp'}
            sx={{ zIndex: '3000' }}
        >
            <>
                <div className={'timer-wrapper'}>
                    <CountdownCircleTimer
                        isPlaying
                        duration={duration}
                        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                        colorsTime={[120, 60, 30, 0]}
                    >
                        {({ remainingTime }) =>
                            renderTime(remainingTime, props.kedo)
                        }
                    </CountdownCircleTimer>
                </div>
                <Box sx={{ textAlign: 'center' }} className={'timer-msg '}>
                    {props.kedo.t('Inactivity detected')}
                </Box>
            </>
        </AppDialog>
    )
}

export default IdleTimeoutPrompt
